export default "__VITE_ASSET__DxNLl1ll__"